/* Approved presentation details; Shopify submission and account handlers are preserved. */
(() => {
  'use strict';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const notice = text => window.dispatchEvent(new CustomEvent('mp2:notice', {detail:text}));
  const newsletterLink = target => {
    const link = target.closest('a');
    return link && /^sign(ing)? up/i.test(link.textContent.trim()) && link.parentElement.querySelector('#p3-newsletter-email') ? link : null;
  };
  function showStatus(id, text) {
    const el = document.getElementById(id);
    if (el) { el.hidden = false; el.textContent = text; }
  }
  const messages = {
    'cf-name': 'Enter your name.',
    'cf-email': 'Enter a valid email address, such as name@example.com.',
    'cf-msg': 'Write a message so we know how to help.'
  };
  function validate(field) {
    const value = field.value.trim();
    const valid = !!value && (field.type !== 'email' || field.validity.valid);
    const error = document.getElementById('p3-error-' + field.id);
    field.setAttribute('aria-invalid', String(!valid));
    if (error) { error.hidden = valid; error.textContent = valid ? '' : messages[field.id]; }
    return valid;
  }
  // Presentation-only feedback; do not intercept checkout, contact, newsletter, or account actions.
  document.addEventListener('click', async event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const action = target.closest('[data-ux-action]');
    const signup = newsletterLink(target);
    if (action?.getAttribute('aria-disabled') === 'true') {
      event.preventDefault(); event.stopImmediatePropagation(); return;
    }
    if (action?.dataset.uxAction === 'copyLink') {
      event.preventDefault(); event.stopImmediatePropagation();
      try { await navigator.clipboard.writeText(location.href); notice('Link copied.'); }
      catch (_) { notice('Could not copy the link. You can copy it from the address bar.'); }
    }
  }, true);
  document.addEventListener('focusout', event => {
    if (event.target.id in messages && event.target.getAttribute('aria-invalid') === 'true') validate(event.target);
  });
  document.addEventListener('input', event => {
    const field = event.target;
    if (field.id in messages && field.getAttribute('aria-invalid') === 'true' && field.value.trim() && (field.type !== 'email' || field.validity.valid)) validate(field);
  });

  const previousSource = new WeakMap(), pending = new WeakSet(), animations = new WeakMap();
  function revealImage(img) {
    if (!pending.has(img)) return;
    pending.delete(img);
    animations.get(img)?.cancel();
    if (reduced.matches || !img.isConnected) return;
    animations.set(img, img.animate([{opacity:.55}, {opacity:1}], {duration:220,easing:'cubic-bezier(.22,1,.36,1)'}));
  }
  function watchImage(img) {
    const source = img.getAttribute('src');
    const before = previousSource.get(img);
    previousSource.set(img, source);
    if (!before || before === source) return;
    pending.add(img);
    const ready = img.decode ? img.decode() : Promise.resolve();
    ready.then(() => { if (img.getAttribute('src') === source) revealImage(img); }).catch(() => { if (img.getAttribute('src') === source) pending.delete(img); });
  }
  function markCurrentRoute() {
    const hash = location.hash.slice(1);
    const route = hash.startsWith('product-') ? 'shop' : hash || (location.pathname.split('/').pop() || '');
    document.querySelectorAll('nav .r-nav-links a').forEach(link => {
      const own = new URL(link.href, location.href).hash.slice(1);
      if (own && own === route) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
  }
  const fittedScreens = new WeakSet();
  function scaleScreenCanvas(screen, width) {
    // Keep the screen's {{ osView.bg }} / {{ osView.text }} bindings intact.
    // Writing to its style before hydration makes the browser discard them.
    const canvas = screen.firstElementChild;
    if (canvas?.classList.contains('p3-os-canvas')) {
      canvas.style.setProperty('--p3-screen-scale', width / 420);
    }
  }
  const fitScreens = new ResizeObserver(entries => {
    for (const {target, contentRect} of entries) scaleScreenCanvas(target, contentRect.width);
  });
  function watchScreen(screen) {
    if (fittedScreens.has(screen)) return;
    fittedScreens.add(screen);
    scaleScreenCanvas(screen, screen.clientWidth);
    fitScreens.observe(screen);
  }
  let queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false; markCurrentRoute();
      document.querySelectorAll('img[data-p3-gallery]').forEach(watchImage);
      document.querySelectorAll('.p3-os-display').forEach(watchScreen);
    });
  }
  function boot() {
    const observer = new MutationObserver(records => {
      if (records.some(record => record.type === 'attributes' && record.target.matches('img[data-p3-gallery]') ||
        record.type === 'childList' && [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('img[data-p3-gallery],.p3-os-display,nav') || node.querySelector('img[data-p3-gallery],.p3-os-display,nav'))))) schedule();
    });
    observer.observe(document.body, {subtree:true,childList:true,attributes:true,attributeFilter:['src']});
    schedule();
    window.addEventListener('hashchange', schedule);
    reduced.addEventListener('change', () => document.querySelectorAll('img[data-p3-gallery]').forEach(img => animations.get(img)?.cancel()));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true});
  else boot();
})();
